import { inRange, isEmpty } from "lodash";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import BetSlipContext from "../../context/BetSlipContext";
import BackandLay from "./BackandLay";
import Keyboard from "./Keyboard";
import BackandLayNew from "./BackAndLayNew";
import { useNavigate } from "react-router-dom";
const ListDetail = ({
  selections,
  back_odds,
  lay_odds,
  details,
  totalMatched,
  setSlipObj,
  setSelections,
  slipObj,
  handelBetFairPositions,
  resetSelection,
  setCondi,
  betType,
  profileData,
  user,
  messaageBox,
  betFairMs,
  setMarketDepth,
  marketId,
}) => {
  const navigate = useNavigate();

  let { handelPlaceBetfair, betSelectionObj, betDelay } =useContext(BetSlipContext);
  const [selectedBet, setSelectedBet] = useState({
    selectionId: "",
    teamName: "",
    check: "",
  });
  const [key, setKey] = useState("");

  const disabledCheck = () => {
    if (details.matchOdds == "off") {
      return "disabled";
    } else {
      return "";
    }
  };

  let check = disabledCheck();

  const temp = () => {};
  return (
    <>
      <div id="marketBetsWrap" className={`bets-wrap asiahadicap ${check}`} onClick={()=>navigate(`/match-details/${details?.eventId}/${details?.marketId}`)}>
        {selections?.length > 0 &&
          selections?.map((item, index) => {
            const filter_odds_back = back_odds?.filter(
              (todd) => todd.ri === item?.SelectionId || item?.selectionId
            );
            const filter_odds_lay = lay_odds?.filter(
              (todd) => todd.ri === item?.SelectionId || item?.selectionId
            );
            return (
              <>
                <dl id="section-1" style={{minHeight:"8.2vw"}} className="bets-selections">
                  <dt>
                    <h4 id="runnerName">{item?.RunnerName || item?.SelectionName}</h4>
                    <ul id="winLoss"></ul>
                  </dt>

                  {betFairMs != 1 && (
                    <dd id="suspend" class="suspend-fancy">
                      <p id="info">
                        {betFairMs == 9
                          ? "Ball Running"
                          : betFairMs == 2
                          ? "In Active"
                          : betFairMs == 3
                          ? "Suspended"
                          : betFairMs == 4
                          ? "Closed"
                          : "Suspended"}
                      </p>
                    </dd>
                  )}
                  <BackandLayNew
                    back={filter_odds_back || []}
                    lay={filter_odds_lay || []}
                    item={item}
                    index={index}
                    details={details}
                  />
                </dl>
              </>
            );
          })}
      </div>
    </>
  );
};

export default ListDetail;
